export const animes = [
  {
    id: "yan-zhi-ji-yuan",
    title: "焰之纪元",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20young%20fire%20warrior%20holding%20a%20blazing%20sword%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20glowing%20orange%20flames%20swirling%20around%2C%20dramatic%20cinematic%20lighting%2C%20simple%20dark%20gradient%20background%2C%20detailed%20character%20design%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-01&orientation=portrait",
    genres: ["热血", "奇幻", "冒险"],
    region: "日本",
    year: 2025,
    status: "连载中",
    rating: 9.2,
    popularity: 9860,
    episodes: 24,
    synopsis:
      "在一个由火焰元素主宰的世界里，少年凛意外继承了古老的焰之力量。为了寻找失踪的兄长，他踏上旅途，逐渐揭开纪元更替背后的惊天秘密。热血与羁绊交织的成长史诗就此展开。",
    tags: ["年度霸权", "高燃", "王道少年漫"],
  },
  {
    id: "xing-hai-bi-duan-de-xin",
    title: "星海彼端的信",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20lone%20girl%20astronaut%20standing%20before%20a%20giant%20space%20station%20window%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20deep%20blue%20starfield%20nebula%20background%2C%20soft%20cinematic%20lighting%2C%20detailed%20character%20design%2C%20melancholic%20sci-fi%20atmosphere%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-02&orientation=portrait",
    genres: ["科幻", "剧情", "悬疑"],
    region: "日本",
    year: 2024,
    status: "已完结",
    rating: 9.0,
    popularity: 8740,
    episodes: 13,
    synopsis:
      "人类向深空派遣的最后一艘探索舰失联百年后，一封跨越星海的讯息神秘传回地球。少女信号官柚木在解读讯息的过程中，逐渐触碰到被刻意封存的真相。",
    tags: ["硬核科幻", "催泪", "完结神作"],
  },
  {
    id: "ying-se-lian-ge",
    title: "樱色恋歌",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20high%20school%20students%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20vibrant%20cel-shaded%20shoujo%20anime%20art%20style%2C%20soft%20pink%20petals%20floating%2C%20warm%20spring%20sunlight%2C%20romantic%20tender%20atmosphere%2C%20detailed%20character%20design%2C%20simple%20bright%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-03&orientation=portrait",
    genres: ["恋爱", "校园", "日常"],
    region: "日本",
    year: 2025,
    status: "连载中",
    rating: 8.7,
    popularity: 7960,
    episodes: 12,
    synopsis:
      "转学生美咲与沉默的美术部少年晴之间，因一张遗落的画稿而结缘。樱花纷飞的三个月里，两个笨拙的灵魂慢慢靠近，谱写出一段青涩而温柔的初恋物语。",
    tags: ["青春恋爱", "治愈系", "细腻作画"],
  },
  {
    id: "tie-jia-lie-shou",
    title: "铁甲猎手",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20giant%20battle%20mecha%20robot%20pilot%20in%20cockpit%20suit%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20steel%20blue%20metallic%20armor%20with%20glowing%20thrusters%2C%20dramatic%20explosive%20lighting%2C%20detailed%20mechanical%20design%2C%20simple%20dark%20background%20with%20sparks%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-04&orientation=portrait",
    genres: ["机战", "热血", "科幻"],
    region: "日本",
    year: 2024,
    status: "连载中",
    rating: 8.9,
    popularity: 8420,
    episodes: 25,
    synopsis:
      "机甲联盟崩溃后，幸存驾驶员组建起地下猎手小队。主角零驾驶着残破的旧世代机体，在一次又一次生死对决中揭开战争背后的阴谋，寻找属于自己的战斗意义。",
    tags: ["硬核机战", "高燃对战", "制作精良"],
  },
  {
    id: "huan-jie-shi-tang",
    title: "幻界食堂",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20cozy%20magical%20diner%20interior%20with%20a%20young%20chef%20girl%20serving%20glowing%20dishes%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20warm%20golden%20lantern%20lighting%2C%20fantasy%20creature%20guests%2C%20healing%20atmosphere%2C%20detailed%20food%20illustration%2C%20simple%20warm%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-05&orientation=portrait",
    genres: ["治愈", "奇幻", "美食"],
    region: "日本",
    year: 2023,
    status: "连载中",
    rating: 8.8,
    popularity: 7120,
    episodes: 36,
    synopsis:
      "在人类与异界交界的森林深处，藏着一间只在满月营业的小食堂。老板娘用一道道温暖料理，化解往来客人心中的遗憾与孤独，编织出一个个治愈人心的故事。",
    tags: ["治愈神作", "美食番", "单元剧"],
  },
  {
    id: "ling-ren-qian-ji",
    title: "灵刃千机",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20of%20a%20sword%20cultivator%20wielding%20a%20glowing%20spirit%20blade%2C%20vibrant%20cel-shaded%20animation%20art%20style%2C%20flowing%20ink%20and%20energy%20ribbons%2C%20dramatic%20red%20and%20gold%20lighting%2C%20detailed%20costume%20design%2C%20simple%20dark%20mountain%20background%2C%20poster%20composition%2C%20high%20quality%20donghua%20promotional%20art&width=600&height=800&seq=wolf-anime-06&orientation=portrait",
    genres: ["武侠", "热血", "奇幻"],
    region: "中国",
    year: 2025,
    status: "连载中",
    rating: 9.1,
    popularity: 9210,
    episodes: 20,
    synopsis:
      "少年铸剑师叶千机在乱世中失去了全部记忆，唯一留下的是一柄会吞噬灵魂的黑刃。他踏入江湖追寻身世，却发现自己的过去正是天下动荡的源头。",
    tags: ["国漫崛起", "水墨打斗", "口碑爆款"],
  },
  {
    id: "shen-hai-hui-xiang",
    title: "深海回响",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20deep%20sea%20diver%20exploring%20glowing%20underwater%20ruins%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20bioluminescent%20blue%20light%20rays%20through%20water%2C%20mysterious%20atmosphere%2C%20detailed%20diving%20suit%20design%2C%20simple%20dark%20ocean%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-07&orientation=portrait",
    genres: ["科幻", "悬疑", "冒险"],
    region: "日本",
    year: 2025,
    status: "连载中",
    rating: 8.6,
    popularity: 7540,
    episodes: 13,
    synopsis:
      "海平面上升后，人类被迫栖居于深海城市。潜水员雾岛在一次勘探中听见来自海底的诡异回响，那声音似乎在呼唤着她的名字，也牵引出被淹没的文明秘密。",
    tags: ["悬疑烧脑", "深海美学", "新番黑马"],
  },
  {
    id: "bai-gui-ye-xing-lu",
    title: "百鬼夜行录",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20exorcist%20facing%20japanese%20yokai%20spirits%20in%20a%20night%20lantern%20festival%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20glowing%20red%20lanterns%20and%20eerie%20mist%2C%20dramatic%20moonlit%20lighting%2C%20detailed%20character%20design%2C%20simple%20dark%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-08&orientation=portrait",
    genres: ["奇幻", "悬疑", "热血"],
    region: "日本",
    year: 2024,
    status: "已完结",
    rating: 8.5,
    popularity: 6780,
    episodes: 24,
    synopsis:
      "每逢满月之夜，都市的阴影里便会浮现百鬼的身影。退魔师家族最后的继承人凛子，带着一只话痨妖狐，在人与妖的纷争中追寻失踪双亲的真相。",
    tags: ["妖怪题材", "战斗番", "已完结"],
  },
  {
    id: "mao-ting-qi-tan",
    title: "猫町奇谭",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20cheerful%20town%20full%20of%20talking%20cats%20in%20a%20colorful%20old%20street%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20bright%20pastel%20colors%2C%20playful%20comedic%20atmosphere%2C%20charming%20cat%20character%20designs%2C%20simple%20warm%20daytime%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-09&orientation=portrait",
    genres: ["搞笑", "治愈", "日常"],
    region: "日本",
    year: 2025,
    status: "连载中",
    rating: 8.4,
    popularity: 6320,
    episodes: 12,
    synopsis:
      "搬家到神秘小镇的女高中生奈奈，发现整条商店街的居民竟然全都是会说话的猫。在帮猫们解决各种奇葩烦恼的过程中，她收获了意想不到的友情与欢笑。",
    tags: ["轻松搞笑", "撸猫番", "下饭神作"],
  },
  {
    id: "cang-qiong-jian-ge",
    title: "苍穹剑歌",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20donghua%20key%20visual%20of%20a%20mysterious%20swordswoman%20standing%20on%20a%20cliff%20above%20clouds%2C%20vibrant%20cel-shaded%20animation%20art%20style%2C%20flowing%20white%20and%20blue%20robe%2C%20epic%20sky%20and%20clouds%20background%2C%20dramatic%20wind%20lighting%2C%20detailed%20character%20design%2C%20poster%20composition%2C%20high%20quality%20donghua%20promotional%20art&width=600&height=800&seq=wolf-anime-10&orientation=portrait",
    genres: ["武侠", "热血", "剧情"],
    region: "中国",
    year: 2024,
    status: "连载中",
    rating: 8.8,
    popularity: 8090,
    episodes: 16,
    synopsis:
      "江湖传闻，得苍穹剑者得天下。剑客苏晚辞却只想用这把剑为逝去的师门讨回公道。刀光剑影中，一段关于信念与牺牲的侠义长歌徐徐奏响。",
    tags: ["国风武侠", "剧情向", "打戏精彩"],
  },
  {
    id: "shi-zhong-ta-de-shao-nv",
    title: "时钟塔的少女",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20girl%20holding%20a%20glowing%20pocket%20watch%20inside%20a%20giant%20clock%20tower%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20steampunk%20gears%20and%20golden%20light%20beams%2C%20mysterious%20fantasy%20atmosphere%2C%20detailed%20costume%20design%2C%20simple%20warm%20dark%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-11&orientation=portrait",
    genres: ["奇幻", "悬疑", "剧情"],
    region: "日本",
    year: 2023,
    status: "已完结",
    rating: 8.9,
    popularity: 7420,
    episodes: 14,
    synopsis:
      "在这座城市最高的时钟塔里，少女菲娅掌管着可以倒转时间的怀表。每当有人前来恳求挽回过去，她都要面对一个艰难的选择：究竟什么才是真正值得被拯救的？",
    tags: ["时间题材", "催泪", "口碑佳作"],
  },
  {
    id: "ji-feng-jing-su",
    title: "疾风竞速",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20determined%20young%20cyclist%20racing%20at%20high%20speed%20on%20a%20track%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20dynamic%20motion%20blur%20and%20speed%20lines%2C%20dramatic%20sunset%20lighting%2C%20passionate%20sports%20atmosphere%2C%20detailed%20character%20design%2C%20simple%20background%2C%20poster%20composition%2C%20high%20quality%20anime%20promotional%20art&width=600&height=800&seq=wolf-anime-12&orientation=portrait",
    genres: ["运动", "热血", "校园"],
    region: "日本",
    year: 2025,
    status: "连载中",
    rating: 8.3,
    popularity: 5980,
    episodes: 22,
    synopsis:
      "被队伍抛弃的自行车手大地，在最落魄的时候遇见了经营旧车行的大叔。带着一台上世纪的赛车，他决定重返赛场，用速度证明永不放弃的信念。",
    tags: ["运动热血", "励志", "燃"],
  },
];